var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { ExtendedOption } from "../types/ExtendedOption";
import { PartnerType } from "../types/PartnerType";
import { CooperationType } from "../types/CooperationType";
import { HealthCareDistrict } from "../types/HealthCareDistrict";
import { MeasurementMethod } from "../types/MeasurementMethod";
import { UpdatedMeasurementMethod } from "../types/UpdatedMeasurementMethod";
import { OperationType } from "../types/OperationType";
import { UpdatedOperationType } from "../types/UpdatedOperationType";
import { CollectionMethod } from "../types/CollectionMethod";
import { TargetGroup } from '../types/TargetGroup';
import { ApartmentTargetGroup } from '../types/ApartmentTargetGroup';
import { BAidType } from '@/common/types/BAidType';
import { MeasurementType } from '../types/MeasurementType';
import { ImpactType } from '../types/ImpactType';
import { ParticipationImpactType } from '../types/ParticipationImpactType';
import { NewOperationPermanenceType } from '../types/NewOperationPermanenceType';
import { OnlineOperationType } from '../types/OnlineOperationType';
import { MeterType } from '../types/MeterType';
import { PeopleTurnover } from '../types/PeopleTurnover';
import { TenderStatus } from '../types/TenderStatus';
import { InvestmentTenderStatus } from '../types/InvestmentTenderStatus';
import { PledgeType } from '../types/PledgeType';
import { RentType } from '../types/RentType';
import { ApartmentRooms } from '../types/ApartmentRooms';
import { HousingType } from '../types/HousingType';
import { PremisesInvestmentType } from '../types/PremisesInvestmentType';
var EnumHelpers = /** @class */ (function (_super) {
    __extends(EnumHelpers, _super);
    function EnumHelpers() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EnumHelpers.prototype.optionsArray = function (options, useKey, useResources) {
        if (useKey === void 0) { useKey = false; }
        if (useResources === void 0) { useResources = false; }
        var TypeEnum;
        var array = [];
        switch (options) {
            case "PartnerTypeOptions": {
                TypeEnum = PartnerType;
                break;
            }
            case "CooperationTypeOptions": {
                TypeEnum = CooperationType;
                break;
            }
            case "HealthCareDistrictOptions": {
                TypeEnum = HealthCareDistrict;
                break;
            }
            case "MeasurementMethodOptions": {
                TypeEnum = MeasurementMethod;
                break;
            }
            case "UpdatedMeasurementMethodOptions": {
                TypeEnum = UpdatedMeasurementMethod;
                break;
            }
            case "MeasurementTypeOptions": {
                TypeEnum = MeasurementType;
                break;
            }
            case "MeterTypeOptions": {
                TypeEnum = MeterType;
                break;
            }
            case "OperationTypeOptions": {
                TypeEnum = OperationType;
                break;
            }
            case "UpdatedOperationTypeOptions": {
                TypeEnum = UpdatedOperationType;
                break;
            }
            case "CollectionMethodOptions": {
                TypeEnum = CollectionMethod;
                break;
            }
            case "UpdatedCollectionMethodOptions": {
                TypeEnum = CollectionMethod;
                break;
            }
            case "TargetGroup": {
                TypeEnum = TargetGroup;
                break;
            }
            case "BOptions": {
                TypeEnum = BAidType;
                break;
            }
            case "ImpactOptions": {
                TypeEnum = ImpactType;
                break;
            }
            case "ImpactOnParticipationOptions": {
                TypeEnum = ParticipationImpactType;
                break;
            }
            case "NewOperationPermanenceOptions": {
                TypeEnum = NewOperationPermanenceType;
                break;
            }
            case "OnlineOperationOptions": {
                TypeEnum = OnlineOperationType;
                break;
            }
            case "PeopleTurnoverOptions": {
                TypeEnum = PeopleTurnover;
                break;
            }
            case "TenderStatus": {
                TypeEnum = TenderStatus;
                break;
            }
            case "InvestmentTenderStatus": {
                TypeEnum = InvestmentTenderStatus;
                break;
            }
            case "ApartmentTargetGroup": {
                TypeEnum = ApartmentTargetGroup;
                break;
            }
            case "PledgeType": {
                TypeEnum = PledgeType;
                break;
            }
            case "RentType": {
                TypeEnum = RentType;
                break;
            }
            case "ApartmentRooms": {
                TypeEnum = ApartmentRooms;
                break;
            }
            case "HousingType": {
                TypeEnum = HousingType;
                break;
            }
            case "PremisesInvestmentType": {
                TypeEnum = PremisesInvestmentType;
                break;
            }
            default:
                break;
        }
        for (var type in TypeEnum) {
            var typeNum = Number(type);
            if (typeNum) {
                var option = new ExtendedOption();
                option.id = typeNum;
                option.name = useResources ? this.$t("Enums." + options + "." + (useKey ? TypeEnum[typeNum] : typeNum)) : "Enums." + options + "." + (useKey ? TypeEnum[typeNum] : typeNum);
                array.push(option);
            }
        }
        return array;
    };
    EnumHelpers = __decorate([
        Component
    ], EnumHelpers);
    return EnumHelpers;
}(Vue));
export { EnumHelpers };
